import { getSmoothStepPath } from '@xyflow/react';

import type { EdgeProps } from '@xyflow/react';

export const FlowEdge = ({ id, sourceX, sourceY, targetX, targetY, markerEnd }: EdgeProps) => {
  const [edgePath] = getSmoothStepPath({ sourceX, sourceY, targetX, targetY, borderRadius: 20 });
  const centerX = (sourceX + targetX) / 2;
  const centerY = (sourceY + targetY) / 2;

  return (
    <>
      <path
        id={id}
        style={{ strokeWidth: 2, stroke: '#C4C9CF' }}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
      <circle
        cx={centerX}
        cy={centerY}
        r={7.5} // 15 / 2
        fill="#FFFFFF"
        stroke="#C4C9CF"
        strokeWidth={2}
      />
    </>
  );
};
